module.exports = __webpack_public_path__ + "static/media/t8.61d8c476.png";